import { create } from 'zustand';
import { ICreateReservationStockItem, IStockOrderProduct, IStockProductAvailabilityData, IStockReservation } from '../types/stockOrders';
import { IproductItemData } from 'types/orders';

interface IStockReservationState {
  stockProductAvailabilityData: IStockProductAvailabilityData[] | null;
  setStockProductAvailabilityData: (stockProductAvailabilityData: IStockProductAvailabilityData[] | null) => void;
  orderItems: IproductItemData[];
  setOrderItems: (orderItems: IproductItemData[]) => void;
  selectedItems: ICreateReservationStockItem[];
  setSelectedItems: (selectedItems: ICreateReservationStockItem[]) => void;
  refreshStockProductAvailabilityData: boolean;
  setRefreshStockProductAvailabilityData: (refreshStockProductAvailabilityData: boolean) => void;
  currentStockReservation: IStockReservation | null;
  setCurrentStockReservation: (currentStockReservation: IStockReservation | null) => void;
  currentSingleSaleId: number | null;
  setCurrentSingleSaleId: (currentSingleSaleId: number | null) => void;
  stockProductsSelected: Pick<IStockOrderProduct, 'sku' | 'items'> | null;
  setStockProductsSelected: (stockProductsSelected: Pick<IStockOrderProduct, 'sku' | 'items'> | null) => void;
  openDownloadModal: boolean;
  setOpenDownloadModal: (openDownloadModal: boolean) => void;
}

const useStockReservationState = create<IStockReservationState>(set => ({
  stockProductAvailabilityData: null,
  setStockProductAvailabilityData: stockProductAvailabilityData => set({ stockProductAvailabilityData }),
  orderItems: [],
  setOrderItems: orderItems => set({ orderItems }),
  selectedItems: [],
  setSelectedItems: selectedItems => set({ selectedItems }),
  refreshStockProductAvailabilityData: true,
  setRefreshStockProductAvailabilityData: refreshStockProductAvailabilityData =>
    set({ refreshStockProductAvailabilityData }),
  currentStockReservation: null,
  setCurrentStockReservation: currentStockReservation => set({ currentStockReservation }),
  currentSingleSaleId: null,
  setCurrentSingleSaleId: currentSingleSaleId => set({ currentSingleSaleId }),
  stockProductsSelected: null,
  setStockProductsSelected: stockProductsSelected => set({ stockProductsSelected }),
  openDownloadModal: false,
  setOpenDownloadModal: openDownloadModal => set({ openDownloadModal })
}));

export default useStockReservationState;
